import { useState } from 'react';

interface ColorPickerProps {
    label: string;
    value: string;
    onChange: (color: string) => void;
    presets?: string[];
}

export default function ColorPicker({ label, value, onChange, presets }: ColorPickerProps) {
    const [inputValue, setInputValue] = useState(value);

    const handleChange = (newColor: string) => {
        setInputValue(newColor);
        if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(newColor)) {
            onChange(newColor);
        }
    };

    const defaultPresets = presets || [
        '#3b82f6', // Blue
        '#8b5cf6', // Purple
        '#10b981', // Green
        '#f59e0b', // Amber
        '#ef4444', // Red
        '#06b6d4', // Cyan
        '#6366f1', // Indigo
        '#ec4899', // Pink
    ];

    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <div className="flex items-center space-x-3">
                <input
                    type="color"
                    value={value}
                    onChange={(e) => handleChange(e.target.value)}
                    className="h-10 w-16 rounded border border-gray-300 cursor-pointer"
                />
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => handleChange(e.target.value)}
                    placeholder="#3b82f6"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
                {defaultPresets.map((preset) => (
                    <button
                        key={preset}
                        onClick={() => handleChange(preset)}
                        className="w-8 h-8 rounded border-2 border-gray-300 hover:border-gray-400 transition"
                        style={{ backgroundColor: preset }}
                        title={preset}
                    />
                ))}
            </div>
        </div>
    );
}
